<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">文章动态</span>
      </div>
    </div>
    <div class="b2Title">
      <span>文章标题</span>
      <input type="text"
             v-model="resTitle" />
      <div>
        <span :style="resTitle.length > 30 ? 'color:red' : ''">{{ resTitle.length }}</span>
        <span>/</span>
        <span>30</span>
      </div>
    </div>
    <div class="b2Count">
      <span>文章正文</span>
    </div>
    <div class="b2Eidter">
      <div id="eidter"
           ref="editer"
           style="z-index:0"></div>
    </div>
    <div class="b2Count">
      <div style="display:flex;align-items: center;">
        <span>关键词：</span>
        <img src="../../assets/img/icon/jia2.png"
             style="cursor: pointer;"
             @click="isKeywords = true"
             alt="" />
      </div>
    </div>
    <div class="b2Key">
      <div class="keybox"
           v-for="(item, index) in resKeywords.split(',')"
           :key="index"
           v-show="item">
        <span>{{ item }}</span>
        <img src="../../assets/img/icon/x.png"
             style="margin:-10px -4px 0 4px;cursor: pointer;"
             @click="toDelKey(item)"
             alt="">
      </div>
    </div>
    <div class="b2Tip">
      <span>专栏分类为必选项，请谨慎选择，分类标签将出现在个人首页动态专栏处</span>
    </div>
    <div class="b2Count">
      <span>我的文章预览：</span>
    </div>
    <div class="b2Preview">
      <p class="b2PTitle">{{ resTitle }}</p>
      <div v-html="count"></div>
    </div>
    <!-- <div class="b2Agreement">
      <div v-show="!isAgree"
           @click="isAgree=true"
           style="border:1px solid #666666"></div>
      <div v-show="isAgree"
           style="background: #0B8586;"
           @click="isAgree=false">
        <img src="../../assets/img/icon/duigou.png"
             alt="">
      </div>
      <span>我已阅读并接受</span>
      <span style="color:#0B8586">《全科学院内容上传协议》</span>
    </div> -->
    <div class="b2Btn">
      <div @click="Submit">保存</div>
      <div @click="quxiao"
           style="background: #9EA2A2;">取消</div>
    </div>
    <el-dialog title="人员导入"
               :visible.sync="isKeywords"
               class="stuLead"
               width="576px">
      <el-form ref="form"
               label-width="68px">
        <el-form-item label="关键词：">
          <el-input v-model="keywords"
                    placeholder="例：家医签约,适宜技术"></el-input>
        </el-form-item>
        <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #0B8586;margin:0 0 40px 70px">关键词输入时，用英文逗号隔开输入</span>
      </el-form>
      <div class="xzbtn"
           @click="addKey">保存</div>
    </el-dialog>
  </div>
</template>

<script>
import E from 'wangeditor';
export default {
  name: 'usInfor',
  data () {
    return {
      orgid: 0,
      resTitle: '',
      resKeywords: '',
      boxIndex: 1,
      isKeywords: false,
      keywords: '',
      count: '',
      editor: null,
      isAgree: false,
      id: 0,
      type: 0
    };
  },
  created () {
    this.orgid = Number(localStorage.getItem('storeId'));
    this.id = Number(this.$route.query.id)
    this.GetMyStoreList();
  },
  mounted () {
    var that = this;
    that.editor = new E(this.$refs.editer);
    that.editor.config.menus = [
      'head',
      'bold',
      'fontSize',
      'fontName',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'link',
      'list',
      'justify',
      'image',
      'undo',
      'redo'
    ];
    that.editor.config.onchange = function (newHtml) {
      that.count = newHtml;
    };
    // 配置触发 onchange 的时间频率，默认为 200ms
    that.editor.config.onchangeTimeout = 500; // 修改为 500ms
    that.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
      const formData = new FormData();
      formData.append('file', resultFiles[0]);
      //   formData.append('Authorid', 0);
      formData.append('OfType', 2);
      that.httphelper.post('/api/OssFileApi/ImageUpload', formData).then(res => {
        if (res.data.code) {
          insertImgFn(res.data.data.src)
        } else {
          that.$message('上传失败');
        }
      });
    }

    that.editor.create();
  },
  methods: {
    GetMyStoreList () {
      this.httphelper
        .post('/api/EnterpriseApi/GetArticleDynamicInfoByID', {
          id: this.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.resTitle = res.data.data.title
            this.count = res.data.data.contentText
            this.resKeywords = res.data.data.labelName
            this.type = res.data.data.state
            this.editor.txt.html(res.data.data.contentText)
          }
        });
    },
    addKey () {
      this.keywords = this.keywords.replace(/，/g, ",")
      if (this.resKeywords == '') this.resKeywords = this.keywords;
      else this.resKeywords = this.resKeywords + ',' + this.keywords;
      this.keywords = '';
      this.isKeywords = false;
    },
    Submit () {
      //   if (this.isAgree == false) return this.$message.warning('请阅读并勾选协议');
      this.httphelper
        .post('/api/EnterpriseApi/SaveArticleDynamic', {
          id: this.id,
          businesId: this.orgid,
          busType: 1,
          title: this.resTitle,
          contentText: this.count,
          labelName: this.resKeywords,
          sort: 0,
          hits: 0,
          releaseTime: '',
          state: this.type,
          approvRemark: '',
          createUserID: JSON.parse(localStorage.getItem('ResData')).id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功');
            this.$router.push({
              name: 'uaDynamic'
            })
          }
        });
    },
    quxiao () {
      this.$router.push({
        name: 'uaDynamic'
      })
    },
    toDelKey (name) {
      let arr = this.resKeywords.split(',')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == name) {
          arr.splice(i, 1);
        }
      }
      this.resKeywords = arr.join(',')
    }
  }
};
</script>

<style scoped>
.box2 {
    padding-top: 20px;
}
.b2Title {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.b2Title input {
    flex: 1;
    margin: 0 10px;
    border: none;
    outline: none;
}
.b2Count {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.b2Btn {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}
.b2Btn div {
    width: 148px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    margin: 0 5px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.b2Key {
    display: flex;
    flex-wrap: wrap;
}
.keybox {
    height: 30px;
    border: 1px solid #0b8586;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    line-height: 30px;
    padding: 0 12px;
    margin-bottom: 10px;
    margin-right: 14px;
    position: relative;
}
.keybox img {
    position: absolute;
    top: 2px;
    right: -4px;
    cursor: pointer;
    background-color: #fff;
    border-radius: 50%;
}
.b2Tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
}
.b2Preview {
    width: 100%;
    height: 333px;
    border: 1px solid #e2e2e2;
    overflow-y: scroll;
    padding: 30px;
    box-sizing: border-box;
}
.b2Preview .b2PTitle {
    margin-bottom: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    text-align: center;
}
.b2Agreement {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 56px;
}
.b2Agreement div {
    width: 15px;
    height: 15px;
    box-sizing: border-box;
    margin-right: 10px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.b2Eidter ::v-deep .w-e-toolbar {
    z-index: 201 !important;
}
.b2Eidter ::v-deep .w-e-text-container {
    z-index: 200 !important;
}
.stuLead ::v-deep .el-dialog {
    padding: 50px 52px;
    border-radius: 10px;
}
.stuLead ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.stuLead ::v-deep .el-dialog__header {
    padding: 0;
    margin-bottom: 30px;
}
.stuLead ::v-deep .el-dialog__body {
    padding: 0;
}
.xzbtn {
    margin-top: 35px;
    margin-left: 136px;
    width: 200px;
    height: 40px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
</style>
